import { AdminSignupPage } from "./AdminSignup";

export const AdminSignupQuick = () => {
  return <AdminSignupPage quick />;
};
